import styled from 'styled-components';

export const StyledActiveIngredientQuantity = styled.div`
   white-space: nowrap;
`;

StyledActiveIngredientQuantity.displayName = 'StyledActiveIngredientQuantity';
